import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let socialLoginRestServiceConfig: IRestfulConfigMap = {
    "socialLoginRestService": {
        appPath: envConfig.appPath("oauth"),
        isAuth: false,
        actions: {
            login: {
                method: "GET",
                path: "/third/oauth/login/:thirdOAuthType/authorize",
                paramDefaults: {
                    thirdOAuthType: "@thirdOAuthType",
                    thirdAccessToken: "@thirdAccessToken"
                },
            },
            register: {
                method: "GET",
                path: "/third/oauth/register/:thirdOAuthType/authorize",
                paramDefaults: {
                    thirdOAuthType: "@thirdOAuthType",
                    thirdAccessToken: "@thirdAccessToken",
                    email: "@email",
                    username: "@username",
                    platform: "@platform"
                }
            }
        }
    }
}

export type ActionKey = "login" | "register";

export { socialLoginRestServiceConfig };
